import { useEffect} from "react";
import liquidExtracts from ".././files/liquid_extracts.json";
import { addDefaultImg } from '../components/imageUtils';

function LiquidExtracts() {

  useEffect(() => {
      document.title = "Liquid Extracts - Deww Botanicals";
    }, []);

  return (
    <>
      {/* // Page Header Start */}
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/liquidExtracts_banner.jpg)`, backgroundPosition: `bottom`}}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Liquid Extracts</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a className="text-body"  Using target="_blank" without rel="noreferrer" href="javascript:void(0);">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item text-dark active" aria-current="page">
                Liquid Extracts
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* // Page Header End */}

      <div className="container-xxl py-4 py-md-5 container-fluid p-0 mb-5 wow fadeIn">
        <div className="container">
          <div className="row g-0 align-items-end">
            <div className="col-12">
              <p>
              Liquid extracts are concentrated solutions made by dissolving the active components of herbs
(leaves, roots, whole, or stems) in a liquid solvent such as alcohol, water, glycol, or glycerin.
These extracts are widely used in herbal medicine, ayurveda, nutraceuticals, pharmaceuticals,
and cosmetic formulations for their potent therapeutic properties and flavors.
              </p>

              <h3>How are Liquid Extracts Extracted?</h3>
              <ul>
                <li>
                Decoction Process: The plant material is boiled in water to extract more robust, hard-to-extract
compounds.
                </li>
                <li>
                Outcome: The liquid is then reduced and filtered, yielding a strong extract.
                </li>
              </ul>

              <h4>Advantages: Liquid extracts can be customized according to the demand.</h4>

              <div className="section-header text-start mb-2 mt-5 ">
                <h2 className="mb-2">Range of Liquid Extracts</h2>
                
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="tab-1" className="tab-pane fade show p-0 active">
              <div className="row g-4">
                {liquidExtracts.map((oil, index) => {
                  return (
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 col-6 "
                      key={index}
                    >
                      <div className="product-item h-100">
                        <div className="position-relative bg-light overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src={oil.image}
                            onError={addDefaultImg}
                            alt={oil.name}
                          />
                          {/* <div className="bg-secondary rounded text-white position-absolute start-0 top-0 m-2 py-1 px-3 nBadge">
                            New
                          </div> */}
                        </div>
                        <div className="text-center p-1 p-md-4 mt-1">
                          <a className="d-block h6 mb-1" Using target="_blank" without rel="noreferrer" href="">
                            {oil.name}
                          </a>
                          <p>{oil.description}</p>
                          {/* <span className="text-primary me-1">$19.00</span>
                          <span className="text-body text-decoration-line-through">
                            $29.00
                          </span> */}
                        </div>
                        {/* <div className="d-flex border-top">
                                    <small className="w-100 text-center py-2">
                                    <Link to="/liquidExtracts" className="text-body"><i className="fa fa-eye text-primary me-2"></i> View detail</Link>
                                    </small>
                                    <small className="w-50 text-center py-2">
                                        <a className="text-body" Using target="_blank" without rel="noreferrer" href=""><i className="fa fa-shopping-bag text-primary me-2"></i>Add to cart</a>
                                    </small>
                                </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LiquidExtracts;
